<div class="min-h-screen bg-[#F3F4F6] dark:bg-slate-900 p-4 md:p-8   text-slate-600 dark:text-slate-300">

  <!-- Header Section -->
  <div class="flex flex-col xl:flex-row xl:items-end justify-between mb-6 xl:mb-8 gap-4">
    <div class="min-w-0 shrink-0">
      <h1 class="text-2xl xl:text-3xl font-extrabold text-slate-800 dark:text-white tracking-tight">
        รายการจอดรถ
        <span class="hidden lg:inline font-extrabold"> (Parking Transactions)</span>
      </h1>
      <p class="text-slate-500 dark:text-slate-400 mt-2 font-medium text-sm xl:text-base">
        ตรวจสอบสถานะและประวัติการจอดรถ
      </p>
    </div>

    <div class="flex flex-wrap items-center gap-2 sm:gap-3 w-full xl:w-auto xl:justify-end min-w-0">
      <!-- Date Filter -->
      <div
        class="flex items-center gap-1.5 sm:gap-2 px-2.5 sm:px-3 py-2 bg-slate-50 dark:bg-slate-800/50 rounded-xl border border-slate-50 dark:border-slate-700 focus-within:bg-white dark:focus-within:bg-slate-800 focus-within:ring-2 focus-within:ring-amber-200 transition-all shadow-sm h-[46px] w-full sm:w-auto sm:flex-1 lg:flex-none min-w-0">
        <span class="material-icons text-slate-400 dark:text-slate-500 text-xl shrink-0">calendar_today</span>

        <div class="relative flex-1 sm:w-[118px] sm:flex-none h-full flex items-center min-w-0">
          <div
            class="absolute inset-0 flex items-center justify-between px-1.5 sm:px-2 font-bold text-xs sm:text-sm text-slate-600 dark:text-slate-300 pointer-events-none font-display">
            <span class="truncate">{{ startDate | date:'dd/MM/yyyy' }}</span>
            <span class="material-icons text-slate-400 dark:text-slate-500 text-lg shrink-0">expand_more</span>
          </div>
          <input #startDatePicker type="date" [(ngModel)]="startDate" (change)="onDateChange()" [max]="endDate"
            (click)="startDatePicker.showPicker()"
            class="opacity-0 w-full h-full cursor-pointer z-10 border-none p-0 focus:ring-0">
        </div>

        <span class="text-slate-300 dark:text-slate-600 shrink-0">-</span>

        <div class="relative flex-1 sm:w-[118px] sm:flex-none h-full flex items-center min-w-0">
          <div
            class="absolute inset-0 flex items-center justify-between px-1.5 sm:px-2 font-bold text-xs sm:text-sm text-slate-600 dark:text-slate-300 pointer-events-none font-display">
            <span class="truncate">{{ endDate | date:'dd/MM/yyyy' }}</span>
            <span class="material-icons text-slate-400 dark:text-slate-500 text-lg shrink-0">expand_more</span>
          </div>
          <input #endDatePicker type="date" [(ngModel)]="endDate" (change)="onDateChange()" [min]="startDate"
            (click)="endDatePicker.showPicker()"
            class="opacity-0 w-full h-full cursor-pointer z-10 border-none p-0 focus:ring-0">
        </div>
      </div>

      <button type="button" (click)="toggleDashboard()"
        class="inline-flex px-3 lg:px-4 h-[46px] bg-white dark:bg-slate-800 text-slate-500 dark:text-slate-400 rounded-xl shadow-sm border border-slate-200 dark:border-slate-600 hover:text-amber-500 hover:shadow-md transition-all active:scale-95 items-center justify-center gap-2 shrink-0"
        [title]="showDashboard ? 'ซ่อน Dashboard' : 'แสดง Dashboard'">
        <span class="material-icons">{{ showDashboard ? 'visibility_off' : 'visibility' }}</span>
        <span class="hidden lg:inline text-sm font-bold whitespace-nowrap">
          {{ showDashboard ? 'ซ่อน Dashboard' : 'แสดง Dashboard' }}
        </span>
      </button>

      <div *ngIf="lastFetchedTime" class="flex flex-col items-end text-right shrink-0 px-1">
        <span class="text-[11px] text-slate-400 dark:text-slate-500 font-medium leading-none mb-1">อัปเดตล่าสุด</span>
        <span class="text-[13px] font-bold text-slate-600 dark:text-slate-400 leading-none tabular-nums">
          {{ lastFetchedTime | date:'HH:mm:ss' }}
        </span>
      </div>

      <label
        class="inline-flex items-center gap-2 px-3 h-[46px] bg-white dark:bg-slate-800 rounded-xl border border-slate-200 dark:border-slate-600 cursor-pointer select-none shrink-0"
        title="เปิดเพื่อดึงข้อมูลอัตโนมัติทุก 1 นาที">
        <input type="checkbox" [(ngModel)]="enableLiveRefresh" (change)="onLiveRefreshToggle()"
          class="w-4 h-4 rounded border-slate-300 text-amber-500 focus:ring-amber-400 shrink-0">
        <span class="text-sm font-bold text-slate-600 dark:text-slate-300 whitespace-nowrap">Live</span>
        <span class="hidden sm:inline text-sm font-bold text-slate-600 dark:text-slate-300 whitespace-nowrap">(1 นาที)</span>
      </label>

      <button type="button" (click)="onRefresh()"
        class="inline-flex w-[46px] h-[46px] px-0 bg-white dark:bg-slate-800 text-slate-500 dark:text-slate-400 rounded-xl shadow-sm border border-slate-200 dark:border-slate-600 hover:text-amber-500 hover:shadow-md transition-all active:scale-95 items-center justify-center shrink-0"
        title="รีเฟรชข้อมูล">
        <span class="material-icons">refresh</span>
      </button>

      <button *ngIf="canCreate" type="button" (click)="openForceEnterModal()"
        class="inline-flex flex-1 sm:flex-none min-w-[9.5rem] px-4 h-[46px] bg-amber-400 hover:bg-amber-500 text-white rounded-xl shadow-sm font-bold text-sm transition-all active:scale-95 items-center justify-center gap-2 shrink-0 whitespace-nowrap"
        title="ทำรายการเข้า">
        <span class="material-icons text-lg shrink-0">login</span>
        <span>ทำรายการเข้า</span>
      </button>
    </div>
  </div>

  <!-- Dashboard Section -->
  <div class="overflow-hidden transition-all duration-500 ease-in-out"
    [style.max-height]="showDashboard ? '2000px' : '0px'" [style.opacity]="showDashboard ? '1' : '0'"
    [style.margin-bottom]="showDashboard ? '2rem' : '0'">

    <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 mb-8 pt-1" *ngIf="showDashboard">

      <!-- Total Transactions -->
      <div role="button" tabindex="0" (click)="setStatusFilter('all')" (keyup.enter)="setStatusFilter('all')"
        class="animate-fade-in stagger-1 bg-white dark:bg-slate-800 rounded-3xl p-6 shadow-[0_4px_20px_rgb(0,0,0,0.03)] border hover:shadow-[0_8px_30px_rgb(0,0,0,0.06)] hover:-translate-y-1 transition-all relative overflow-hidden group cursor-pointer"
        [ngClass]="statusFilter === 'all' ? 'border-amber-300 dark:border-amber-600 ring-2 ring-amber-200/60 dark:ring-amber-700/40' : 'border-slate-100 dark:border-slate-700'">
        <div
          class="absolute -right-6 -top-6 w-32 h-32 rounded-full bg-blue-500 opacity-[0.08] group-hover:scale-110 transition-transform">
        </div>
        <div class="relative z-10 flex justify-between items-start mb-4">
          <div class="w-12 h-12 rounded-2xl bg-blue-50 text-blue-600 flex items-center justify-center shadow-sm">
            <span class="material-icons text-2xl">local_parking</span>
          </div>
        </div>
        <div class="relative z-10">
          <h4 class="text-slate-400 dark:text-slate-500 text-xs font-bold uppercase tracking-wider mb-1">รายการทั้งหมด
          </h4>
          <div class="text-2xl font-black text-slate-800 dark:text-white tracking-tight">{{
            dashboardStats.totalTransactions |
            number }}</div>
        </div>
      </div>

      <!-- Active Count (In Park) -->
      <div role="button" tabindex="0" (click)="setStatusFilter('active')" (keyup.enter)="setStatusFilter('active')"
        class="animate-fade-in stagger-2 bg-white dark:bg-slate-800 rounded-3xl p-6 shadow-[0_4px_20px_rgb(0,0,0,0.03)] border hover:shadow-[0_8px_30px_rgb(0,0,0,0.06)] hover:-translate-y-1 transition-all relative overflow-hidden group cursor-pointer"
        [ngClass]="statusFilter === 'active' ? 'border-emerald-300 dark:border-emerald-600 ring-2 ring-emerald-200/60 dark:ring-emerald-700/40' : 'border-slate-100 dark:border-slate-700'">
        <div
          class="absolute -right-6 -top-6 w-32 h-32 rounded-full bg-amber-500 opacity-[0.08] group-hover:scale-110 transition-transform">
        </div>
        <div class="relative z-10 flex justify-between items-start mb-4">
          <div class="w-12 h-12 rounded-2xl bg-amber-50 text-amber-600 flex items-center justify-center shadow-sm">
            <span class="material-icons text-2xl">directions_car</span>
          </div>
        </div>
        <div class="relative z-10">
          <h4 class="text-slate-400 dark:text-slate-500 text-xs font-bold uppercase tracking-wider mb-1">กำลังจอดอยู่
          </h4>
          <div class="text-2xl font-black text-slate-800 dark:text-white tracking-tight">{{ dashboardStats.activeCount |
            number
            }}</div>
        </div>
      </div>

      <!-- Completed Count (Exited) -->
      <div role="button" tabindex="0" (click)="setStatusFilter('completed')"
        (keyup.enter)="setStatusFilter('completed')"
        class="animate-fade-in stagger-3 bg-white dark:bg-slate-800 rounded-3xl p-6 shadow-[0_4px_20px_rgb(0,0,0,0.03)] border hover:shadow-[0_8px_30px_rgb(0,0,0,0.06)] hover:-translate-y-1 transition-all relative overflow-hidden group cursor-pointer"
        [ngClass]="statusFilter === 'completed' ? 'border-slate-400 dark:border-slate-500 ring-2 ring-slate-200/70 dark:ring-slate-600/50' : 'border-slate-100 dark:border-slate-700'">
        <div
          class="absolute -right-6 -top-6 w-32 h-32 rounded-full bg-emerald-500 opacity-[0.08] group-hover:scale-110 transition-transform">
        </div>
        <div class="relative z-10 flex justify-between items-start mb-4">
          <div class="w-12 h-12 rounded-2xl bg-emerald-50 text-emerald-600 flex items-center justify-center shadow-sm">
            <span class="material-icons text-2xl">check_circle</span>
          </div>
        </div>
        <div class="relative z-10">
          <h4 class="text-slate-400 dark:text-slate-500 text-xs font-bold uppercase tracking-wider mb-1">ออกแล้ว</h4>
          <div class="text-2xl font-black text-slate-800 dark:text-white tracking-tight">{{
            dashboardStats.completedCount | number
            }}
          </div>
        </div>
      </div>

      <!-- Longest Duration List -->
      <div
        class="animate-fade-in stagger-4 bg-white dark:bg-slate-800 rounded-3xl p-5 shadow-[0_4px_20px_rgb(0,0,0,0.03)] border border-slate-100 dark:border-slate-700 hover:shadow-[0_8px_30px_rgb(0,0,0,0.06)] hover:-translate-y-1 transition-all relative overflow-hidden group flex flex-col">
        <div
          class="absolute -right-6 -top-6 w-32 h-32 rounded-full bg-rose-500 opacity-[0.08] group-hover:scale-110 transition-transform">
        </div>

        <div class="relative z-10 flex items-center justify-between mb-3">
          <div class="flex items-center gap-3">
            <div class="w-10 h-10 rounded-xl bg-rose-50 text-rose-600 flex items-center justify-center shadow-sm">
              <span class="material-icons text-xl">timer</span>
            </div>
            <div>
              <h4 class="text-slate-400 dark:text-slate-500 text-[10px] font-bold uppercase tracking-wider">จอดนานที่สุด
              </h4>
              <span class="text-xs font-bold text-slate-700 dark:text-slate-200">Longest Duration</span>
            </div>
          </div>

        </div>

        <div class="relative z-10 flex-1 flex flex-col gap-2 overflow-y-auto custom-scrollbar pr-1 max-h-[100px]">
          <div *ngFor="let item of dashboardStats.longestParkingList"
            class="grid grid-cols-10 items-center gap-1 group/item p-1.5 hover:bg-rose-50 rounded-lg transition-colors border-b border-dashed border-slate-100 dark:border-slate-700 last:border-0 border-opacity-50">

            <!-- Col 1: License (3 cols) -->
            <div class="col-span-3 flex items-center gap-1.5 overflow-hidden">
              <span class="material-icons text-[14px] text-slate-400 dark:text-slate-500 shrink-0">{{
                getVehicleIcon(item.vehicleType)
                }}</span>
              <span class="text-xs font-bold text-slate-700 dark:text-slate-200 font-display truncate"
                [title]="item.license">{{
                item.license }}</span>
            </div>

            <!-- Col 2: Site Name (4 cols - Center) -->
            <div class="col-span-4 flex justify-center overflow-hidden px-1">
              <span
                class="text-[10px] text-slate-500 dark:text-slate-400 truncate flex items-center gap-0.5 bg-slate-100/50 px-1.5 py-0.5 rounded-md max-w-full"
                [title]="item.siteName">
                <span class="material-icons text-[10px] text-slate-400 dark:text-slate-500">place</span>{{ item.siteName
                }}
              </span>
            </div>

            <!-- Col 3: Duration (3 cols - Right) -->
            <div class="col-span-3 flex flex-col items-end shrink-0">
              <span class="text-xs font-bold font-display text-right whitespace-nowrap leading-tight"
                [ngClass]="item.isOvertime ? 'text-rose-500' : 'text-slate-600 dark:text-slate-300'">{{
                item.durationText }}</span>
              <span class="text-[9px] text-right leading-tight"
                [ngClass]="item.isActive ? 'text-emerald-500' : 'text-slate-400 dark:text-slate-500'">{{ item.isActive ?
                'กำลังจอด' :
                'ออกแล้ว' }}</span>
            </div>

          </div>

          <div *ngIf="dashboardStats.longestParkingList.length === 0"
            class="flex-1 flex items-center justify-center text-slate-300 dark:text-slate-600 text-xs italic">
            ไม่มีข้อมูล
          </div>
        </div>

      </div>
    </div>

  </div>


  <!-- Chart & Recent Activity Section -->
  <div class="grid grid-cols-1 lg:grid-cols-3 gap-8 mb-8 transition-all duration-500 ease-in-out"
    [style.max-height]="showDashboard ? '1200px' : '0px'" [style.opacity]="showDashboard ? '1' : '0'"
    [style.margin-bottom]="showDashboard ? '2rem' : '0'">

    <!-- Chart -->
    <div
      class="lg:col-span-2 bg-white dark:bg-slate-800 rounded-3xl shadow-[0_4px_20px_rgb(0,0,0,0.03)] border border-slate-100 dark:border-slate-700 p-6 pb-10 overflow-hidden">

      <div class="flex flex-col gap-6">
        <div class="flex flex-col sm:flex-row sm:items-center justify-between gap-4">
          <div class="flex items-center gap-3">
            <div class="w-10 h-10 rounded-xl bg-amber-50 text-amber-500 flex items-center justify-center">
              <span class="material-icons">analytics</span>
            </div>
            <div>
              <h3 class="text-lg font-bold text-slate-800 dark:text-white">ปริมาณการจอดรถ</h3>
              <span class="text-xs text-slate-400 dark:text-slate-500 font-medium">
                แสดงข้อมูลตามช่วงเวลา
                <span *ngIf="chartMode === 'daily' && dailySubMode === 'default'">
                  ( {{ chartStartDate | date: 'dd/MM/yyyy' }} - {{ chartEndDate | date: 'dd/MM/yyyy' }} )
                </span>
                <span *ngIf="chartMode === 'daily' && dailySubMode === 'custom'">
                  ( สูงสุด 10 วัน)
                </span>
                <span *ngIf="chartMode === 'monthly'">
                  ( {{ selectedMonthStart | date: 'MM/yyyy' }} - {{ selectedMonthEnd | date: 'MM/yyyy' }}
                  )
                </span>
              </span>
            </div>
          </div>

          <!-- Chart Controls -->
          <div class="flex flex-col items-end gap-2">

            <!-- Row 1: Inputs & Sub-Modes -->
            <div class="flex items-center gap-2 min-h-[34px]">

              <!-- Daily Controls -->
              <div *ngIf="chartMode === 'daily'" class="flex items-center gap-2">
                <div
                  class="flex bg-slate-50 dark:bg-slate-800/50 border border-slate-200 dark:border-slate-600 rounded-lg p-0.5 gap-1">
                  <button (click)="setDailySubMode('default')"
                    class="px-2 py-1 text-xs font-medium rounded-md transition-all"
                    [ngClass]="dailySubMode === 'default' ? 'bg-white dark:bg-slate-800 text-slate-800 dark:text-white shadow-sm' : 'text-slate-400 dark:text-slate-500 hover:text-slate-600 dark:hover:text-slate-300'">
                    7 วันล่าสุด
                  </button>
                  <button (click)="setDailySubMode('custom')"
                    class="px-2 py-1 text-xs font-medium rounded-md transition-all"
                    [ngClass]="dailySubMode === 'custom' ? 'bg-white dark:bg-slate-800 text-slate-800 dark:text-white shadow-sm' : 'text-slate-400 dark:text-slate-500 hover:text-slate-600 dark:hover:text-slate-300'">
                    กำหนดเอง
                  </button>
                </div>

                <div *ngIf="dailySubMode === 'custom'"
                  class="flex items-center bg-slate-50 dark:bg-slate-800/50 border border-slate-200 dark:border-slate-600 rounded-lg px-2 py-1">
                  <input type="date" [(ngModel)]="customStartDate" (change)="onCustomDateChange()" [max]="customEndDate"
                    class="bg-transparent border-none text-xs text-slate-600 dark:text-slate-300 font-medium focus:ring-0 p-0 w-24">
                  <span class="mx-1 text-slate-300 dark:text-slate-600">-</span>
                  <input type="date" [(ngModel)]="customEndDate" (change)="onCustomDateChange()" [min]="customStartDate"
                    [max]="maxCustomDate"
                    class="bg-transparent border-none text-xs text-slate-600 dark:text-slate-300 font-medium focus:ring-0 p-0 w-24">

                  <button (click)="resetCustomDate()"
                    class="ml-2 w-5 h-5 flex items-center justify-center rounded-full hover:bg-slate-100 dark:hover:bg-slate-700 text-slate-400 dark:text-slate-500 hover:text-amber-500 transition-colors"
                    title="รีเซ็ตเป็น 10 วันล่าสุด">
                    <span class="material-icons text-[16px]">refresh</span>
                  </button>
                </div>
              </div>

              <!-- Monthly Inputs -->
              <div *ngIf="chartMode === 'monthly'"
                class="flex items-center gap-2 bg-slate-50 dark:bg-slate-800/50 border border-slate-200 dark:border-slate-600 rounded-lg px-2 py-1">
                <input type="month" [(ngModel)]="selectedMonthStart" (change)="onChartMonthChange()"
                  class="bg-transparent border-none text-xs font-bold text-slate-600 dark:text-slate-300 p-0 focus:ring-0 outline-none w-[110px]">
                <span class="text-slate-300 dark:text-slate-600 mx-1">-</span>
                <input type="month" [(ngModel)]="selectedMonthEnd" (change)="onChartMonthChange()"
                  class="bg-transparent border-none text-xs font-bold text-slate-600 dark:text-slate-300 p-0 focus:ring-0 outline-none w-[110px]">
              </div>

            </div>

            <!-- Row 2: Toggles -->
            <div class="flex items-center gap-2">
              <!-- Type Toggle -->
              <div class="flex bg-slate-100 dark:bg-slate-700 p-1 rounded-lg">
                <button (click)="setChartType('line')"
                  [class]="chartType === 'line' ? 'bg-white dark:bg-slate-800 text-slate-800 dark:text-white shadow-sm' : 'text-slate-500 dark:text-slate-400 hover:text-slate-700 dark:hover:text-slate-200'"
                  class="p-1 px-2 rounded-md transition-all" title="Line Chart">
                  <span class="material-icons text-sm">show_chart</span>
                </button>
                <button (click)="setChartType('bar')"
                  [class]="chartType === 'bar' ? 'bg-white dark:bg-slate-800 text-slate-800 dark:text-white shadow-sm' : 'text-slate-500 dark:text-slate-400 hover:text-slate-700 dark:hover:text-slate-200'"
                  class="p-1 px-2 rounded-md transition-all" title="Bar Chart">
                  <span class="material-icons text-sm">bar_chart</span>
                </button>
              </div>

              <!-- Mode Toggle -->
              <div class="flex bg-slate-100 dark:bg-slate-700 p-1 rounded-lg">
                <button (click)="setChartMode('daily')"
                  [class]="chartMode === 'daily' ? 'bg-white dark:bg-slate-800 text-slate-800 dark:text-white shadow-sm' : 'text-slate-500 dark:text-slate-400 hover:text-slate-700 dark:hover:text-slate-200'"
                  class="px-3 py-1 text-xs font-bold rounded-md transition-all">รายวัน</button>
                <button (click)="setChartMode('monthly')"
                  [class]="chartMode === 'monthly' ? 'bg-white dark:bg-slate-800 text-slate-800 dark:text-white shadow-sm' : 'text-slate-500 dark:text-slate-400 hover:text-slate-700 dark:hover:text-slate-200'"
                  class="px-3 py-1 text-xs font-bold rounded-md transition-all">รายเดือน</button>
              </div>
            </div>

          </div>
        </div>

        <div class="relative h-64 w-full">
          <svg viewBox="0 0 100 100" class="w-full h-full overflow-visible" preserveAspectRatio="none">
            <defs>
              <linearGradient id="gradientArea" x1="0" x2="0" y1="0" y2="1">
                <stop offset="0%" stop-color="#fbbf24" stop-opacity="0.4" />
                <stop offset="100%" stop-color="#fbbf24" stop-opacity="0" />
              </linearGradient>
            </defs>

            <!-- Grid Lines -->
            <g class="text-slate-200 dark:text-slate-700">
              <line x1="0" y1="100" x2="100" y2="100" stroke="currentColor" stroke-width="0.5" />
              <line x1="0" y1="75" x2="100" y2="75" stroke="currentColor" stroke-width="0.5" stroke-dasharray="2" />
              <line x1="0" y1="50" x2="100" y2="50" stroke="currentColor" stroke-width="0.5" stroke-dasharray="2" />
              <line x1="0" y1="25" x2="100" y2="25" stroke="currentColor" stroke-width="0.5" stroke-dasharray="2" />
              <line x1="0" y1="0" x2="100" y2="0" stroke="currentColor" stroke-width="0.5" stroke-dasharray="2" />
            </g>

            <!-- Current Area & Line -->
            <!-- Line Chart -->
            <g *ngIf="chartType === 'line'">
              <polygon [attr.points]="currentMonthAreaPoints" fill="url(#gradientArea)"
                class="opacity-50 transition-all duration-500" />
              <polyline [attr.points]="currentMonthPoints" fill="none" stroke="#fbbf24" stroke-width="0.5"
                stroke-linecap="round" stroke-linejoin="round" class="drop-shadow-sm transition-all duration-500" />

              <!-- Dots (Hover effect) -->
              <circle *ngFor="let point of currentMonthDots" [attr.cx]="point.x" [attr.cy]="point.y" r="1.5" fill="#fff"
                stroke="#fbbf24" stroke-width="1" class="opacity-0 hover:opacity-100 transition-opacity cursor-pointer">
                <title>{{ point.label }}: {{ point.value }}</title>
              </circle>
            </g>

            <!-- Bar Chart -->
            <g *ngIf="chartType === 'bar'">
              <rect *ngFor="let point of currentMonthDots" [attr.x]="point.x - 2" [attr.y]="point.y" width="4"
                [attr.height]="100 - point.y" [attr.fill]="point.color"
                class="hover:opacity-80 hover:fill-yellow-500 border-2 border-white transition-all duration-300 cursor-pointer rx-[1px]">
                <title>{{ point.label }}: {{ point.value }}</title>
              </rect>
            </g>
          </svg>

          <!-- Y-Axis Labels (Left Side) -->
          <div
            class="absolute inset-y-0 left-[-30px] bottom-2 w-8 flex flex-col justify-between text-[9px] text-yellow-400 font-medium pointer-events-none py-0 items-end pr-1">
            <span>{{ yAxisLabels[4] }}</span>
            <span>{{ yAxisLabels[3] }}</span>
            <span>{{ yAxisLabels[2] }}</span>
            <span>{{ yAxisLabels[1] }}</span>
            <span class="translate-y-2">{{ yAxisLabels[0] }}</span>
          </div>

          <!-- Dynamic Labels -->
          <div class="absolute bottom-0 left-0 right-0 translate-y-8 h-8 pointer-events-none">
            <ng-container *ngFor="let dot of currentMonthDots; let i = index">
              <div
                *ngIf="(currentMonthDots.length <= 15) || (i % 5 === 0) || i === 0 || i === currentMonthDots.length - 1"
                class="absolute top-0 flex flex-col items-center whitespace-nowrap" [style.left.%]="dot.x"
                style="transform: translateX(-50%);">
                <span class="text-[10px] text-slate-400 dark:text-slate-500 font-medium">{{ dot.label }}</span>
                <span *ngIf="dot.subLabel" class="text-[9px] text-slate-400 dark:text-slate-500">{{ dot.subLabel
                  }}</span>
              </div>
            </ng-container>
          </div>
        </div>
      </div>

    </div>

    <!-- Recent Activity -->
    <div
      class="lg:col-span-1 bg-white dark:bg-slate-800 rounded-3xl shadow-[0_4px_20px_rgb(0,0,0,0.03)] border border-slate-100 dark:border-slate-700 p-8">
      <h3 class="text-xl font-bold text-slate-800 dark:text-white mb-6">รายการล่าสุด</h3>
      <div class="relative">
        <div class="absolute left-5 top-4 bottom-4 w-0.5 bg-slate-100 dark:bg-slate-700"></div>
        <div class="space-y-6 relative">
          <div *ngFor="let item of recentActivity" class="flex items-start gap-4 group">
            <div
              class="w-10 h-10 rounded-full flex-shrink-0 flex items-center justify-center text-white text-sm font-bold shadow-md ring-4 ring-white dark:ring-slate-800 z-10"
              [ngClass]="item.color">
              {{ item.initial }}
            </div>
            <div class="flex-1 pt-1">
              <div class="flex justify-between items-start">
                <h5
                  class="text-sm font-bold text-slate-800 dark:text-white group-hover:text-amber-500 transition-colors">
                  {{ item.name }}</h5>
                <span
                  class="text-[10px] font-semibold text-slate-400 dark:text-slate-500 bg-slate-50 dark:bg-slate-800/50 px-2 py-0.5 rounded-full border border-slate-100 dark:border-slate-700 whitespace-nowrap">{{
                  item.timeAgo }}</span>
              </div>
              <p class="text-xs text-slate-500 dark:text-slate-400 mt-0.5">{{ item.info }}</p>
            </div>
          </div>
          <div *ngIf="recentActivity.length === 0" class="text-center text-slate-400 dark:text-slate-500 py-10">
            <span class="material-icons text-3xl mb-2 opacity-50">history</span>
            <p class="text-sm">ไม่มีกิจกรรมล่าสุด</p>
          </div>
        </div>
      </div>
    </div>

  </div>

  <!-- Mobile Filter Toggle Button (floating) -->
  <button (click)="toggleMobileFilter()"
    class="md:hidden fixed bottom-6 left-6 z-50 w-14 h-14 bg-amber-400 dark:bg-amber-500 text-white rounded-2xl shadow-xl shadow-amber-200/50 dark:shadow-amber-900/30 flex items-center justify-center hover:bg-amber-500 dark:hover:bg-amber-600 active:scale-95 transition-all animate-float">
    <span class="material-icons text-2xl">tune</span>
    <span *ngIf="activeFilterCount > 0"
      class="absolute -top-1.5 -right-1.5 w-5 h-5 bg-rose-500 text-white text-[10px] font-bold rounded-full flex items-center justify-center shadow-md animate-badge-pop">
      {{ activeFilterCount }}
    </span>
  </button>

  <!-- Mobile Filter Backdrop -->
  <div *ngIf="showMobileFilter" (click)="closeMobileFilter()"
    class="md:hidden fixed inset-0 z-40 bg-black/40 backdrop-blur-sm animate-overlay"></div>

  <!-- Main Content -->
  <div
    class="bg-white dark:bg-slate-800 rounded-3xl shadow-[0_4px_20px_rgb(0,0,0,0.03)] border border-slate-100 dark:border-slate-700 overflow-hidden flex flex-col md:flex-row h-full min-h-[600px]  ">

    <!-- Sidebar Filter -->
    <div
      class="w-72 md:w-64 border-r border-slate-100 dark:border-slate-700 p-6 bg-slate-50/50 dark:bg-slate-800/50 flex flex-col gap-4 overflow-y-auto custom-scrollbar animate-slide-in-left"
      [ngClass]="{'fixed inset-y-0 left-0 z-50 shadow-2xl': showMobileFilter, 'hidden md:flex': !showMobileFilter}">

      <!-- Sidebar Header -->
      <div class="flex items-center justify-between">
        <h3 class="text-base font-extrabold text-slate-800 dark:text-white flex items-center gap-2">
          <span class="material-icons text-amber-500 text-lg">filter_list</span> ตัวกรอง
        </h3>
        <div class="flex items-center gap-2">
          <button *ngIf="activeFilterCount > 0" (click)="clearAllFilters()"
            class="text-[11px] text-rose-500 hover:text-rose-600 font-bold flex items-center gap-1 px-2 py-1 rounded-lg hover:bg-rose-50 dark:hover:bg-rose-900/20 transition-all">
            <span class="material-icons text-[14px]">clear_all</span> ล้างทั้งหมด
          </button>
          <button (click)="closeMobileFilter()"
            class="md:hidden p-1 hover:bg-slate-100 dark:hover:bg-slate-700 rounded-lg transition-colors">
            <span class="material-icons text-slate-400 dark:text-slate-500">close</span>
          </button>
        </div>
      </div>

      <!-- Active Filter Summary -->
      <div *ngIf="activeFilterCount > 0"
        class="flex items-center gap-2 px-3 py-2 bg-amber-50 dark:bg-amber-900/20 rounded-xl border border-amber-100 dark:border-amber-800/30">
        <span class="material-icons text-amber-500 text-sm">info</span>
        <span class="text-xs text-amber-700 dark:text-amber-400 font-bold">{{ activeFilterCount }}
          ตัวกรองที่ใช้งาน</span>
      </div>

      <!-- Status Filter -->
      <div>
        <div (click)="toggleFilterSection('status')"
          class="flex items-center justify-between mb-3 cursor-pointer select-none group">
          <h3
            class="text-sm font-bold text-slate-800 dark:text-white flex items-center gap-2 group-hover:text-amber-500 transition-colors">
            <span
              class="material-icons text-sm text-slate-400 dark:text-slate-500 group-hover:text-amber-500 transition-colors">filter_alt</span>
            สถานะ
            <span *ngIf="statusFilter !== 'all'"
              class="w-5 h-5 bg-amber-400 text-white text-[10px] font-bold rounded-full flex items-center justify-center animate-badge-pop">1</span>
          </h3>
          <span class="material-icons text-slate-400 dark:text-slate-500 text-sm filter-chevron transition-transform"
            [class.rotated]="isFilterCollapsed('status')">expand_more</span>
        </div>
        <div class="filter-section-content" [class.collapsed]="isFilterCollapsed('status')"
          [class.expanded]="!isFilterCollapsed('status')">
          <div class="flex flex-col gap-1.5">

            <!-- All -->
            <label class="relative cursor-pointer" (click)="setStatusFilter('all'); $event.preventDefault()">
              <input type="radio" name="statusFilter" [value]="'all'" [checked]="statusFilter === 'all'"
                class="sr-only peer">
              <div class="flex items-center gap-2.5 px-3 py-2 rounded-xl border transition-all duration-200
                          border-transparent bg-transparent
                          peer-checked:bg-white peer-checked:dark:bg-slate-800
                          peer-checked:border-amber-200 peer-checked:dark:border-amber-700/50
                          peer-checked:shadow-sm
                          hover:bg-white dark:hover:bg-slate-700/50">
                <div
                  class="w-4 h-4 rounded-full border-2 transition-all duration-200 shrink-0 flex items-center justify-center bg-white dark:bg-slate-800"
                  [ngClass]="statusFilter === 'all' ? 'border-amber-500' : 'border-slate-300 dark:border-slate-500'">
                  <div class="w-2 h-2 rounded-full bg-amber-500 transition-all duration-200"
                    [ngClass]="statusFilter === 'all' ? 'opacity-100 scale-100' : 'opacity-0 scale-0'"></div>
                </div>
                <span class="text-sm font-semibold transition-colors duration-200"
                  [ngClass]="statusFilter === 'all' ? 'text-amber-600 dark:text-amber-400' : 'text-slate-600 dark:text-slate-400'">
                  ทั้งหมด
                </span>
                <span class="ml-auto text-[10px] font-bold px-1.5 py-0.5 rounded-full"
                  [ngClass]="statusFilter === 'all' ? 'bg-amber-100 dark:bg-amber-900/30 text-amber-600 dark:text-amber-400' : 'bg-slate-100 dark:bg-slate-700 text-slate-400 dark:text-slate-500'">
                  All
                </span>
              </div>
            </label>

            <!-- Active -->
            <label class="relative cursor-pointer" (click)="setStatusFilter('active'); $event.preventDefault()">
              <input type="radio" name="statusFilter" [value]="'active'" [checked]="statusFilter === 'active'"
                class="sr-only peer">
              <div class="flex items-center gap-2.5 px-3 py-2 rounded-xl border transition-all duration-200
                          border-transparent bg-transparent
                          peer-checked:bg-white peer-checked:dark:bg-slate-800
                          peer-checked:border-emerald-200 peer-checked:dark:border-emerald-700/50
                          peer-checked:shadow-sm
                          hover:bg-white dark:hover:bg-slate-700/50">
                <div
                  class="w-4 h-4 rounded-full border-2 transition-all duration-200 shrink-0 flex items-center justify-center bg-white dark:bg-slate-800"
                  [ngClass]="statusFilter === 'active' ? 'border-emerald-500' : 'border-slate-300 dark:border-slate-500'">
                  <div class="w-2 h-2 rounded-full bg-emerald-500 transition-all duration-200"
                    [ngClass]="statusFilter === 'active' ? 'opacity-100 scale-100' : 'opacity-0 scale-0'"></div>
                </div>
                <span class="text-sm font-semibold transition-colors duration-200 flex items-center gap-1.5"
                  [ngClass]="statusFilter === 'active' ? 'text-emerald-600 dark:text-emerald-400' : 'text-slate-600 dark:text-slate-400'">
                  <span class="w-1.5 h-1.5 rounded-full bg-emerald-500 animate-pulse inline-block"
                    *ngIf="statusFilter === 'active'"></span>
                  กำลังจอด
                </span>
              </div>
            </label>

            <!-- Completed -->
            <label class="relative cursor-pointer" (click)="setStatusFilter('completed'); $event.preventDefault()">
              <input type="radio" name="statusFilter" [value]="'completed'" [checked]="statusFilter === 'completed'"
                class="sr-only peer">
              <div class="flex items-center gap-2.5 px-3 py-2 rounded-xl border transition-all duration-200
                          border-transparent bg-transparent
                          peer-checked:bg-white peer-checked:dark:bg-slate-800
                          peer-checked:border-slate-200 peer-checked:dark:border-slate-600
                          peer-checked:shadow-sm
                          hover:bg-white dark:hover:bg-slate-700/50">
                <div
                  class="w-4 h-4 rounded-full border-2 transition-all duration-200 shrink-0 flex items-center justify-center bg-white dark:bg-slate-800"
                  [ngClass]="statusFilter === 'completed' ? 'border-slate-500 dark:border-slate-400' : 'border-slate-300 dark:border-slate-500'">
                  <div class="w-2 h-2 rounded-full bg-slate-500 dark:bg-slate-400 transition-all duration-200"
                    [ngClass]="statusFilter === 'completed' ? 'opacity-100 scale-100' : 'opacity-0 scale-0'"></div>
                </div>
                <span class="text-sm font-semibold transition-colors duration-200 flex items-center gap-1.5"
                  [ngClass]="statusFilter === 'completed' ? 'text-slate-700 dark:text-slate-300' : 'text-slate-600 dark:text-slate-400'">
                  <span class="material-icons text-[12px] text-slate-400"
                    *ngIf="statusFilter === 'completed'">check_circle</span>
                  ออกแล้ว
                </span>
              </div>
            </label>

          </div>
        </div>
      </div>

      <!-- <div class="w-full border-t border-slate-200 dark:border-slate-600"></div> -->

      <!-- Current Site (from global SiteStateService) -->
      <!-- <div>
        <div class="flex items-center justify-between mb-3">
          <h3 class="text-sm font-bold text-slate-800 dark:text-white flex items-center gap-2">
            <span class="material-icons text-sm text-slate-400 dark:text-slate-500">location_on</span>
            สาขาที่เลือก
          </h3>
        </div>
        <div
          class="flex items-center gap-2 px-3 py-2.5 bg-amber-50 dark:bg-amber-900/20 border border-amber-200 dark:border-amber-800/50 rounded-xl">
          <span class="material-icons text-amber-500 text-base">place</span>
          <span class="text-sm font-bold text-amber-800 dark:text-amber-300 truncate">
            {{ siteState.selectedSite()?.name || '— ยังไม่ได้เลือกสาขา —' }}
          </span>
        </div>
        <p class="text-[11px] text-slate-400 dark:text-slate-500 mt-2 px-1">เปลี่ยนสาขาได้จากเมนูด้านซ้าย —
          ข้อมูลจะโหลดใหม่อัตโนมัติ</p>
      </div> -->

      <!-- Gate Filter (Collapsible) -->
      <div class="border-t border-slate-200 dark:border-slate-600 pt-4">
        <div (click)="toggleFilterSection('gate')"
          class="flex items-center justify-between mb-3 cursor-pointer select-none group">
          <h3
            class="text-sm font-bold text-slate-800 dark:text-white flex items-center gap-2 group-hover:text-amber-500 transition-colors">
            <span
              class="material-icons text-sm text-slate-400 dark:text-slate-500 group-hover:text-amber-500 transition-colors">door_sliding</span>
            จุดเข้า-ออก
            <span *ngIf="activeGateCount > 0"
              class="w-5 h-5 bg-amber-400 text-white text-[10px] font-bold rounded-full flex items-center justify-center animate-badge-pop">{{
              activeGateCount }}</span>
          </h3>
          <div class="flex items-center gap-1">
            <button (click)="$event.stopPropagation(); resetGateFilter()"
              class="text-xs text-amber-500 hover:text-amber-600 px-1.5 py-0.5 rounded hover:bg-amber-50 dark:hover:bg-amber-900/20 transition-all"
              *ngIf="gateSearchText || (selectedGates | json) !== '{}'">
              ล้าง
            </button>
            <span class="material-icons text-slate-400 dark:text-slate-500 text-sm filter-chevron"
              [class.rotated]="isFilterCollapsed('gate')">expand_more</span>
          </div>
        </div>

        <div class="filter-section-content" [class.collapsed]="isFilterCollapsed('gate')"
          [class.expanded]="!isFilterCollapsed('gate')">
          <!-- Gate Search -->
          <div class="mb-3 relative group filter-input-focus rounded-lg">
            <input type="text" [(ngModel)]="gateSearchText" placeholder="ค้นหาจุดเข้า-ออก..."
              class="w-full pl-8 pr-3 py-1.5 text-sm bg-white dark:bg-slate-800 border border-slate-200 dark:border-slate-600 rounded-lg focus:outline-none focus:ring-2 focus:ring-amber-100 focus:border-amber-400 transition-all text-slate-600 dark:text-slate-300 placeholder:text-slate-400 dark:placeholder:text-slate-500">
            <span
              class="material-icons absolute left-2 top-2 text-slate-400 dark:text-slate-500 text-[18px] group-focus-within:text-amber-500 transition-colors">search</span>
          </div>

          <div class="flex flex-col gap-1.5 max-h-[200px] overflow-y-auto custom-scrollbar pr-1">
            <label *ngFor="let gate of filteredGateOptions"
              class="flex items-center gap-3 cursor-pointer group p-1.5 hover:bg-white dark:hover:bg-slate-700 rounded-lg transition-all hover:shadow-sm border border-transparent hover:border-slate-100 dark:hover:border-slate-600">
              <div class="relative flex items-center justify-center">
                <input type="checkbox" [checked]="selectedGates[gate]" (change)="toggleGate(gate)"
                  class="peer appearance-none w-5 h-5 border-2 border-slate-300 dark:border-slate-500 rounded-md focus:ring-amber-400 checked:bg-amber-400 checked:border-amber-400 transition-all cursor-pointer">
                <span
                  class="material-icons absolute text-white opacity-0 peer-checked:opacity-100 transition-opacity pointer-events-none"
                  style="font-size: 14px;">check</span>
              </div>
              <span
                class="text-sm text-slate-600 dark:text-slate-300 group-hover:text-slate-900 transition-colors font-medium select-none flex-1 truncate">{{
                gate }}</span>
            </label>
            <div *ngIf="filteredGateOptions.length === 0"
              class="text-xs text-slate-400 dark:text-slate-500 italic p-2 text-center">
              ไม่พบข้อมูลจุดเข้า-ออก</div>
          </div>
        </div>
      </div>

      <!-- Vehicle Type Filter (Collapsible) -->
      <div class="border-t border-slate-200 dark:border-slate-600 pt-4">
        <div (click)="toggleFilterSection('vehicleType')"
          class="flex items-center justify-between mb-3 cursor-pointer select-none group">
          <h3
            class="text-sm font-bold text-slate-800 dark:text-white flex items-center gap-2 group-hover:text-amber-500 transition-colors">
            <span
              class="material-icons text-sm text-slate-400 dark:text-slate-500 group-hover:text-amber-500 transition-colors">directions_car</span>
            ประเภทรถ
            <span *ngIf="activeVehicleTypeCount > 0"
              class="w-5 h-5 bg-amber-400 text-white text-[10px] font-bold rounded-full flex items-center justify-center animate-badge-pop">{{
              activeVehicleTypeCount }}</span>
          </h3>
          <div class="flex items-center gap-1">
            <button (click)="$event.stopPropagation(); resetVehicleTypeFilter()"
              class="text-xs text-amber-500 hover:text-amber-600 px-1.5 py-0.5 rounded hover:bg-amber-50 dark:hover:bg-amber-900/20 transition-all"
              *ngIf="(selectedVehicleTypes | json) !== '{}'">
              ล้าง
            </button>
            <span class="material-icons text-slate-400 dark:text-slate-500 text-sm filter-chevron"
              [class.rotated]="isFilterCollapsed('vehicleType')">expand_more</span>
          </div>
        </div>

        <div class="filter-section-content" [class.collapsed]="isFilterCollapsed('vehicleType')"
          [class.expanded]="!isFilterCollapsed('vehicleType')">
          <div class="flex flex-col gap-1.5 max-h-[200px] overflow-y-auto custom-scrollbar pr-1">
            <label *ngFor="let type of vehicleTypeOptions"
              class="flex items-center gap-3 cursor-pointer group p-1.5 hover:bg-white dark:hover:bg-slate-700 rounded-lg transition-all hover:shadow-sm border border-transparent hover:border-slate-100 dark:hover:border-slate-600">
              <div class="relative flex items-center justify-center">
                <input type="checkbox" [checked]="selectedVehicleTypes[type]" (change)="toggleVehicleType(type)"
                  class="peer appearance-none w-5 h-5 border-2 border-slate-300 dark:border-slate-500 rounded-md focus:ring-amber-400 checked:bg-amber-400 checked:border-amber-400 transition-all cursor-pointer">
                <span
                  class="material-icons absolute text-white opacity-0 peer-checked:opacity-100 transition-opacity pointer-events-none"
                  style="font-size: 14px;">check</span>
              </div>
              <span
                class="text-sm text-slate-600 dark:text-slate-300 group-hover:text-slate-900 transition-colors font-medium select-none flex-1 truncate">{{
                type }}</span>
            </label>
            <div *ngIf="vehicleTypeOptions.length === 0"
              class="text-xs text-slate-400 dark:text-slate-500 italic p-2 text-center">
              ไม่พบข้อมูลประเภทรถ</div>
          </div>
        </div>
      </div>

    </div>

    <!-- Table Content -->
    <!-- Main Content Right Side -->
    <div class="flex-1 flex flex-col min-w-0 bg-white dark:bg-slate-800">

      <!-- Table Toolbar -->
      <div
        class="px-5 py-3.5 border-b border-slate-100 dark:border-slate-700/70 flex items-center justify-between gap-4 flex-wrap">
        <div class="flex items-center gap-3 flex-wrap">
          <span class="text-sm font-semibold text-slate-500 dark:text-slate-400">
            แสดง <span class="font-black text-slate-800 dark:text-white">{{ totalItems | number }}</span> รายการ
          </span>

          <!-- Primary status filter — always hits API -->
          <div
            class="flex items-center p-1 bg-slate-50 dark:bg-slate-900 border border-slate-100 dark:border-slate-700 rounded-xl h-[40px] shadow-sm overflow-x-auto">
            <button type="button" (click)="setStatusFilter('all')"
              class="px-3 h-full rounded-lg text-sm font-bold transition-all whitespace-nowrap cursor-pointer"
              [ngClass]="statusFilter === 'all' ? 'bg-white dark:bg-slate-700 text-amber-600 dark:text-amber-400 shadow-sm' : 'text-slate-400 hover:text-amber-600'">
              ทั้งหมด
            </button>
            <div class="w-px h-4 bg-slate-200 dark:bg-slate-700 mx-0.5"></div>
            <button type="button" (click)="setStatusFilter('active')"
              class="px-3 h-full rounded-lg text-sm font-bold transition-all whitespace-nowrap cursor-pointer"
              [ngClass]="statusFilter === 'active' ? 'bg-white dark:bg-slate-700 text-emerald-600 dark:text-emerald-400 shadow-sm' : 'text-slate-400 hover:text-emerald-600'">
              กำลังจอด
            </button>
            <div class="w-px h-4 bg-slate-200 dark:bg-slate-700 mx-0.5"></div>
            <button type="button" (click)="setStatusFilter('completed')"
              class="px-3 h-full rounded-lg text-sm font-bold transition-all whitespace-nowrap cursor-pointer"
              [ngClass]="statusFilter === 'completed' ? 'bg-white dark:bg-slate-700 text-slate-700 dark:text-slate-200 shadow-sm' : 'text-slate-400 hover:text-slate-600'">
              ออกแล้ว
            </button>
          </div>

          <!-- Bulk Actions -->
          <div *ngIf="selectedTransactions.size > 0" class="flex items-center gap-2 animate-fade-in">
            <span
              class="inline-flex items-center gap-1.5 text-[11px] font-bold text-amber-700 dark:text-amber-300 bg-amber-50 dark:bg-amber-900/20 px-3 py-1.5 rounded-full border border-amber-200 dark:border-amber-700/50">
              <span class="w-1.5 h-1.5 rounded-full bg-amber-500 animate-pulse"></span>
              เลือก {{ selectedTransactions.size }} คัน
            </span>
            <button (click)="openBulkCloseModal()"
              class="inline-flex items-center gap-1.5 px-3 py-1.5 bg-rose-500 hover:bg-rose-600 text-white text-[11px] font-bold rounded-full shadow-sm shadow-rose-500/30 hover:shadow-rose-500/50 transition-all active:scale-95">
              <span class="material-icons text-[14px]">logout</span>
              รถออกพร้อมกัน
            </button>
          </div>
        </div>

        <!-- Search Bar -->
        <div class="relative group w-full sm:w-auto z-30">
          <div
            class="flex items-center h-[38px] bg-slate-50 dark:bg-slate-700/50 border border-slate-200 dark:border-slate-600 rounded-2xl shadow-sm focus-within:ring-2 focus-within:ring-amber-300/40 focus-within:border-amber-400 focus-within:bg-white dark:focus-within:bg-slate-700 transition-all">

            <!-- Dropdown Trigger -->
            <button (click)="toggleSearchTypeDropdown()"
              class="px-3 h-full flex items-center gap-1.5 border-r border-slate-200 dark:border-slate-600 hover:bg-slate-100/50 dark:hover:bg-slate-600/50 transition-colors text-slate-500 dark:text-slate-400 text-xs font-bold whitespace-nowrap rounded-l-xl">
              <span>{{ currentSearchTypeLabel }}</span>
              <span class="material-icons text-sm">expand_more</span>
            </button>

            <!-- Input -->
            <div class="relative flex-1 min-w-[180px]">
              <!-- <span
                class="material-icons absolute left-3 top-1/2 -translate-y-1/2 text-slate-400 dark:text-slate-500 text-[16px]">search</span> -->
              <input type="text" [(ngModel)]="searchText" (keyup.enter)="filterData()" placeholder="ค้นหา..."
                class="w-full h-full pl-3 pr-7 border-none focus:ring-0 text-sm placeholder:text-slate-400 dark:placeholder:text-slate-500 text-slate-700 dark:text-slate-200 bg-transparent outline-none">
              <button *ngIf="searchText" (click)="searchText = ''; filterData()"
                class="absolute right-2 top-1/2 -translate-y-1/2 text-slate-400 hover:text-slate-600 dark:hover:text-slate-300 transition-colors">
                <span class="material-icons text-[14px]">close</span>
              </button>
            </div>

            <button (click)="filterData()"
              class="px-2.5 h-full bg-white hover:bg-amber-500/10 cursor-pointer shadow rounded-r-2xl text-slate-400 dark:text-slate-500 hover:text-amber-500 transition-colors flex items-center justify-center">
              <span class="material-icons text-[16px]">search</span>
            </button>
          </div>

          <!-- Dropdown Menu -->
          <div *ngIf="isSearchTypeDropdownOpen"
            class="absolute top-full left-0 mt-2 w-44 bg-white dark:bg-slate-800 rounded-xl shadow-xl border border-slate-100 dark:border-slate-700 overflow-hidden flex flex-col py-1 animate-fade-in-down z-50">
            <button (click)="selectSearchType('license_plate')"
              class="text-left px-4 py-2.5 hover:bg-slate-50 dark:hover:bg-slate-700/50 text-sm text-slate-600 dark:text-slate-300 hover:text-amber-500 flex items-center gap-2">
              <span class="material-icons text-base text-slate-400">directions_car</span> ทะเบียนรถ
            </button>
            <button (click)="selectSearchType('gate_name')"
              class="text-left px-4 py-2.5 hover:bg-slate-50 dark:hover:bg-slate-700/50 text-sm text-slate-600 dark:text-slate-300 hover:text-amber-500 flex items-center gap-2">
              <span class="material-icons text-base text-slate-400">door_sliding</span> จุดเข้า-ออก
            </button>
            <button (click)="selectSearchType('card_name')"
              class="text-left px-4 py-2.5 hover:bg-slate-50 dark:hover:bg-slate-700/50 text-sm text-slate-600 dark:text-slate-300 hover:text-amber-500 flex items-center gap-2">
              <span class="material-icons text-base text-slate-400">badge</span> บัตร/สมาชิก
            </button>
          </div>

          <!-- Backdrop -->
          <div *ngIf="isSearchTypeDropdownOpen" (click)="isSearchTypeDropdownOpen = false"
            class="fixed inset-0 z-40 bg-transparent"></div>
        </div>
      </div>

      <!-- Table Wrapper -->
      <div class="flex-1 overflow-x-auto overflow-y-auto custom-scrollbar relative">
        <table class="w-full text-sm text-left text-slate-600 dark:text-slate-300 border-separate border-spacing-0">
          <thead
            class="text-[11px] text-slate-400 dark:text-slate-500 uppercase tracking-wider bg-slate-50/80 dark:bg-slate-800/80 sticky top-0 z-10 backdrop-blur-sm">
            <tr>
              <th *ngIf="canEdit" class="px-4 py-3.5 w-[48px] text-center border-b border-slate-100 dark:border-slate-700/50">
                <label class="custom-checkbox-container" title="เลือกทั้งหมดที่ยังไม่ออก">
                  <input type="checkbox" [checked]="isAllSelected" (change)="toggleSelectAll()"
                    [disabled]="!hasActiveTransactions" class="custom-checkbox-input">
                  <span class="checkbox-checkmark"></span>
                </label>
              </th>
              <th (click)="sortData('entryLicense')"
                class="px-4 py-3.5 font-bold cursor-pointer hover:text-slate-600 dark:hover:text-slate-300 transition-colors border-b border-slate-100 dark:border-slate-700/50 w-[20%]">
                <div class="flex items-center gap-1">
                  ทะเบียนรถ
                  <span class="material-icons text-[12px] opacity-0 text-amber-500 transition-all"
                    [class.opacity-100]="sortColumn === 'entryLicense'">
                    {{ sortColumn === 'entryLicense' && sortDirection === 'asc' ? 'arrow_upward' : 'arrow_downward' }}
                  </span>
                </div>
              </th>
              <th (click)="sortData('cardName')"
                class="px-4 py-3.5 font-bold cursor-pointer hover:text-slate-600 dark:hover:text-slate-300 transition-colors border-b border-slate-100 dark:border-slate-700/50 w-[14%]">
                <div class="flex items-center gap-1">
                  บัตร
                  <span class="material-icons text-[12px] opacity-0 text-amber-500 transition-all"
                    [class.opacity-100]="sortColumn === 'cardName'">
                    {{ sortColumn === 'cardName' && sortDirection === 'asc' ? 'arrow_upward' : 'arrow_downward' }}
                  </span>
                </div>
              </th>
              <th class="px-4 py-3.5 font-bold text-center border-b border-slate-100 dark:border-slate-700/50 w-[8%]">
                สมาชิก</th>
              <th (click)="sortData('entryDate')"
                class="px-4 py-3.5 font-bold cursor-pointer hover:text-slate-600 dark:hover:text-slate-300 transition-colors border-b border-slate-100 dark:border-slate-700/50 w-[18%]">
                <div class="flex items-center gap-1">
                  เวลา เข้า → ออก
                  <span class="material-icons text-[12px] opacity-0 text-amber-500 transition-all"
                    [class.opacity-100]="sortColumn === 'entryDate'">
                    {{ sortColumn === 'entryDate' && sortDirection === 'asc' ? 'arrow_upward' : 'arrow_downward' }}
                  </span>
                </div>
              </th>
              <th (click)="sortData('siteName')"
                class="px-4 py-3.5 font-bold cursor-pointer hover:text-slate-600 dark:hover:text-slate-300 transition-colors border-b border-slate-100 dark:border-slate-700/50 w-[14%]">
                <div class="flex items-center gap-1">
                  สถานที่
                  <span class="material-icons text-[12px] opacity-0 text-amber-500 transition-all"
                    [class.opacity-100]="sortColumn === 'siteName'">
                    {{ sortColumn === 'siteName' && sortDirection === 'asc' ? 'arrow_upward' : 'arrow_downward' }}
                  </span>
                </div>
              </th>
              <th class="px-4 py-3.5 font-bold text-center border-b border-slate-100 dark:border-slate-700/50 w-[12%]">
                ระยะเวลา</th>
              <th class="px-4 py-3.5 font-bold text-center border-b border-slate-100 dark:border-slate-700/50 w-[10%]">
                จัดการ</th>
            </tr>
          </thead>

          <tbody class="text-sm">
            <tr *ngFor="let item of transactions; let i = index"
              (click)="openDetailModal(item)"
              class="animate-table-row border-b border-slate-50 dark:border-slate-700/30 hover:bg-amber-50/40 dark:hover:bg-slate-700/20 transition-colors duration-150 group cursor-pointer"
              [class.bg-amber-50]="selectedTransactions.has(item.id)"
              [class.dark:bg-amber-900]="selectedTransactions.has(item.id)" [style.animation-delay.ms]="i * 35">

              <!-- Checkbox -->
              <td *ngIf="canEdit" class="px-4 py-4 align-middle text-center" (click)="$event.stopPropagation()">
                <label class="custom-checkbox-container" *ngIf="!item.exitDate">
                  <input type="checkbox" [checked]="selectedTransactions.has(item.id)"
                    (change)="toggleSelection(item.id)" class="custom-checkbox-input">
                  <span class="checkbox-checkmark"></span>
                </label>
                <div *ngIf="item.exitDate"
                  class="w-5 h-5 mx-auto rounded-full bg-slate-100 dark:bg-slate-700 flex items-center justify-center">
                  <span class="material-icons text-[12px] text-slate-300 dark:text-slate-500">check</span>
                </div>
              </td>

              <!-- Vehicle + Images -->
              <td class="px-4 py-4 align-middle">
                <div class="flex items-center gap-3">
                  <!-- Entry Image -->
                  <div
                    (click)="openImageModal(item.entryPath1 ? 'https://pss-upload.cloud/Parkingcaptures/' + item.entryPath1 : 'img/notfound.jpg'); $event.stopPropagation()"
                    class="relative shrink-0 cursor-zoom-in group/img overflow-hidden rounded-xl w-20 h-[52px] bg-slate-100 dark:bg-slate-700 border border-slate-200 dark:border-slate-600">
                    <img
                      [src]="item.entryPath1 ? 'https://pss-upload.cloud/Parkingcaptures/' + item.entryPath1 : 'img/notfound.jpg'"
                      class="w-full h-full object-cover transition-transform duration-500 group-hover/img:scale-110">
                    <div class="absolute inset-0 bg-black/0 group-hover/img:bg-black/10 transition-all"></div>
                    <!-- <div
                      class="absolute bottom-0 left-0 right-0 py-0.5 text-center bg-emerald-500/80 text-white text-[8px] font-black tracking-wide">
                      เข้า</div> -->
                  </div>

                  <!-- Info -->
                  <div class="flex flex-col gap-1 min-w-0">
                    <div class="flex items-center gap-1.5 flex-wrap">
                      <span class="text-[15px] font-black text-slate-800 dark:text-white tracking-tight">
                        {{ item.entryLicense || '-' }}
                      </span>
                      <!-- Premium Edit Button -->
                      <button (click)="openEditLicenseModal(item); $event.stopPropagation()" *ngIf="canEdit && !item.exitDate"
                        class="shrink-0 inline-flex items-center gap-0.5  transition-all px-1.5 py-0.5 bg-amber-50 hover:bg-amber-400 border border-amber-200 hover:border-amber-400 rounded-md text-amber-500 hover:text-white text-[12px] font-bold">
                        <span class="material-icons" style="font-size: 16px;">edit</span>
                        แก้
                      </button>
                    </div>
                    <span
                      class="inline-flex items-center gap-1 text-[10px] font-semibold text-slate-400 dark:text-slate-500">
                      <span class="material-icons text-[11px] text-amber-400">{{ getVehicleIcon(item.vehicleTypeName)
                        }}</span>
                      {{ item.vehicleTypeName || 'ทั่วไป' }}
                    </span>
                    <span *ngIf="item.exitLicense   && item.exitLicense !== item.entryLicense"
                      class="inline-flex items-center gap-1 text-[10px] font-bold text-rose-500 bg-rose-50 dark:bg-rose-900/20 px-1.5 py-0.5 rounded-md w-fit">
                      <span class="material-icons text-[11px]">swap_horiz</span>
                      ออก: {{ item.exitLicense === 'unknown' ? 'ไม่พบทะเบียน' : item.exitLicense }}
                    </span>
                  </div>
                </div>
              </td>

              <!-- Card -->
              <td class="px-4 py-4 align-middle">
                <div class="flex flex-col gap-0.5">
                  <span class="text-[11px] text-slate-400 dark:text-slate-500 font-medium">บัตร</span>
                  <span (click)="toggleCardExpand(item.id, $event)"
                    class="text-sm font-bold text-slate-700 dark:text-slate-200 cursor-pointer hover:text-amber-500"
                    [class.truncate]="!expandedCardIds.has(item.id)"
                    [class.max-w-[140px]]="!expandedCardIds.has(item.id)"
                    [class.whitespace-normal]="expandedCardIds.has(item.id)"
                    [title]="expandedCardIds.has(item.id) ? '' : item.cardName">{{ item.cardName || '-' }}</span>
                  <span class="text-[10px] font-mono text-slate-400 dark:text-slate-500 cursor-pointer hover:text-amber-500"
                    (click)="toggleCardExpand(item.id, $event)"
                    [class.truncate]="!expandedCardIds.has(item.id)"
                    [class.max-w-[140px]]="!expandedCardIds.has(item.id)"
                    [class.whitespace-normal]="expandedCardIds.has(item.id)"
                    [title]="expandedCardIds.has(item.id) ? '' : item.cardCode">{{
                    item.cardCode || '-' }}</span>
                  <span *ngIf="item.oldTicket"
                    class="inline-flex items-center gap-1 mt-1 text-[10px] font-bold text-rose-500 bg-rose-50 dark:bg-rose-900/20 px-1.5 py-0.5 rounded-md w-fit">
                    <span class="material-icons text-[11px]">warning</span>
                    Ref: {{ item.oldTicket }}
                  </span>
                </div>
              </td>

              <!-- Member / Visitor -->
              <td class="px-4 py-4 align-middle text-center">
                <span *ngIf="item.member"
                  class="inline-flex items-center gap-1 text-[11px] font-black text-emerald-600 dark:text-emerald-400 bg-emerald-50 dark:bg-emerald-900/20 px-2.5 py-1 rounded-full border border-emerald-200 dark:border-emerald-700/50">
                  <span class="material-icons text-[13px]">verified</span>
                  Member
                </span>
                <span *ngIf="!item.member"
                  class="inline-flex items-center gap-1 text-[11px] font-bold text-slate-400 dark:text-slate-500 bg-slate-50 dark:bg-slate-700/40 px-2.5 py-1 rounded-full border border-slate-200 dark:border-slate-600">
                  Visitor
                </span>
              </td>

              <!-- Time Only (no site) -->
              <td class="px-4 py-4 align-middle">
                <div class="flex flex-col gap-2">
                  <!-- Entry time -->
                  <div class="flex items-start gap-2">
                    <div
                      class="w-2 h-2 rounded-full bg-emerald-400 shrink-0 mt-1.5 ring-2 ring-emerald-100 dark:ring-emerald-900">
                    </div>
                    <div class="flex flex-col min-w-0">
                      <span class="text-[10px] text-slate-400 dark:text-slate-500 truncate">{{ item.entryGateName ||
                        'ไม่ระบุ' }}</span>
                      <span class="text-xs font-bold text-slate-700 dark:text-slate-200">{{
                        formatDateDisplay(item.entryDate) }}</span>
                    </div>
                  </div>
                  <!-- Exit time -->
                  <div class="flex items-start gap-2">
                    <div class="w-2 h-2 rounded-full shrink-0 mt-1.5 ring-2 transition-colors"
                      [ngClass]="item.exitDate ? 'bg-rose-400 ring-rose-100 dark:ring-rose-900' : 'bg-slate-200 dark:bg-slate-600 ring-slate-100 dark:ring-slate-700'">
                    </div>
                    <div class="flex flex-col min-w-0">
                      <span class="text-[10px] text-slate-400 dark:text-slate-500 truncate">{{ item.exitGateName ||
                        (item.exitDate ? 'ไม่ระบุ' : 'ยังไม่ออก') }}</span>
                      <span *ngIf="item.exitDate" class="text-xs font-bold text-slate-700 dark:text-slate-200">{{
                        formatDateDisplay(item.exitDate) }}</span>
                      <span *ngIf="!item.exitDate"
                        class="text-[10px] italic text-emerald-500 font-semibold">ยังอยู่ในพื้นที่</span>
                    </div>
                  </div>
                </div>
              </td>

              <!-- Site Column (new) -->
              <td class="px-4 py-4 align-middle">
                <div class="flex flex-col gap-0.5">
                  <span class="text-[10px] text-slate-400 dark:text-slate-500 font-medium">สถานที่</span>
                  <span class="text-xs font-bold text-slate-700 dark:text-slate-200 line-clamp-2">{{ item.siteName ||
                    '-' }}</span>
                </div>
              </td>

              <!-- Duration -->
              <td class="px-4 py-4 align-middle text-center">
                <!-- Active: no duration yet -->
                <ng-container *ngIf="!item.exitDate">
                  <span
                    class="inline-flex items-center gap-1.5 text-[10px] font-bold text-emerald-600 dark:text-emerald-400 bg-emerald-50 dark:bg-emerald-900/20 px-2.5 py-1.5 rounded-full border border-emerald-100 dark:border-emerald-800/50">
                    <span class="w-1.5 h-1.5 rounded-full bg-emerald-500 animate-pulse"></span>
                    กำลังจอด
                  </span>
                </ng-container>
                <!-- Completed: show duration -->
                <ng-container *ngIf="item.exitDate">
                  <div class="flex flex-col items-center gap-1">
                    <div
                      class="flex items-center gap-1 px-2.5 py-1.5 bg-violet-50 dark:bg-violet-900/20 rounded-lg border border-violet-100 dark:border-violet-800/40">
                      <span class="material-icons text-violet-400" style="font-size: 16px;">schedule</span>
                      <span
                        class="inline-flex items-center gap-1 text-[10px] font-semibold text-slate-400 dark:text-slate-500">
                        {{
                        calculateDuration(item.entryDate, item.exitDate) }}</span>

                    </div>
                    <span class="text-[10px] text-slate-400 dark:text-slate-500 font-medium">ออกแล้ว</span>
                  </div>
                </ng-container>
              </td>

              <!-- Actions -->
              <td class="px-4 py-4 align-middle">
                <div class="flex flex-col items-center gap-2">
                  <ng-container *ngIf="!item.exitDate">
                    <button (click)="openDetailModal(item); $event.stopPropagation()"
                      class="w-8 h-8 flex items-center justify-center rounded-lg bg-slate-50 dark:bg-slate-700/50 border border-slate-200 dark:border-slate-600 text-slate-400 hover:text-blue-500 hover:bg-blue-50 dark:hover:bg-blue-900/20 hover:border-blue-200 dark:hover:border-blue-700 transition-all active:scale-95"
                      title="ดูรายละเอียด">
                      <span class="material-icons text-[16px]">visibility</span>
                    </button>
                    <button *ngIf="canEdit" type="button" (click)="openForceExitModal(item); $event.stopPropagation()"
                      class="w-8 h-8 flex items-center justify-center rounded-lg bg-rose-50 dark:bg-rose-900/10 border border-rose-200 dark:border-rose-800/50 text-rose-500 hover:bg-rose-500 hover:text-white hover:border-rose-500 transition-all active:scale-95"
                      title="ทำรายการออก">
                      <span class="material-icons text-[16px]">logout</span>
                    </button>
                  </ng-container>
                  <ng-container *ngIf="item.exitDate">
                    <button (click)="openDetailModal(item); $event.stopPropagation()"
                      class="w-8 h-8 flex items-center justify-center rounded-lg bg-slate-50 dark:bg-slate-700/50 border border-slate-200 dark:border-slate-600 text-slate-400 hover:text-blue-500 hover:bg-blue-50 dark:hover:bg-blue-900/20 hover:border-blue-200 transition-all active:scale-95"
                      title="ดูรายละเอียด">
                      <span class="material-icons text-[16px]">visibility</span>
                    </button>
                  </ng-container>
                </div>
              </td>
            </tr>

            <!-- Empty State -->
            <tr *ngIf="transactions.length === 0">
              <td [attr.colspan]="canEdit ? 8 : 7" class="py-20 text-center">
                <div class="flex flex-col items-center justify-center animate-fade-in">
                  <div
                    class="w-16 h-16 bg-slate-100 dark:bg-slate-700 rounded-2xl flex items-center justify-center mb-4">
                    <span class="material-icons text-3xl text-slate-300 dark:text-slate-500">local_parking</span>
                  </div>
                  <h3 class="text-base font-bold text-slate-700 dark:text-slate-200 mb-1">ไม่พบรายการจอดรถ</h3>
                  <p class="text-sm text-slate-400 dark:text-slate-500 max-w-xs">ลองปรับตัวกรองหรือคำค้นหาใหม่</p>
                  <button (click)="clearAllFilters()"
                    class="mt-4 px-4 py-2 bg-white dark:bg-slate-800 border border-slate-200 dark:border-slate-700 shadow-sm rounded-lg text-sm font-bold text-slate-600 dark:text-slate-400 hover:text-amber-500 dark:hover:text-amber-400 hover:border-amber-300 dark:hover:border-amber-600 transition-all flex items-center gap-1.5">
                    <span class="material-icons text-base">filter_list_off</span> ล้างตัวกรองทั้งหมด
                  </button>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- Pagination Footer -->
      <div
        class="px-6 py-4 border-t border-slate-100 dark:border-slate-700 bg-white dark:bg-slate-800 flex flex-col md:flex-row items-center justify-between gap-4 rounded-b-3xl">
        <div class="flex items-center gap-4 text-sm text-slate-500 dark:text-slate-400 font-medium">
          <span>แสดง {{ startItemIndex | number }} - {{ endItemIndex | number }} จาก {{ totalItems | number }}
            รายการ</span>
          <select (change)="onPageSizeChange($event)" [(ngModel)]="pageSize"
            class="bg-slate-50 dark:bg-slate-800/50 border border-slate-200 dark:border-slate-600 text-slate-700 dark:text-slate-200 text-sm rounded-lg focus:ring-2 focus:ring-amber-100 focus:border-amber-400 block p-1.5 pr-8 font-bold outline-none cursor-pointer hover:bg-white dark:hover:bg-slate-700 transition-colors">
            <option *ngFor="let size of pageSizeOptions" [value]="size">{{ size }} / หน้า</option>
          </select>
        </div>

        <div class="flex items-center gap-2">
          <button (click)="onPageChange(currentPage - 1)" [disabled]="currentPage === 1"
            class="w-9 h-9 flex items-center justify-center rounded-lg border border-slate-200 dark:border-slate-600 hover:bg-slate-50 dark:hover:bg-slate-700/50 hover:text-amber-500 disabled:opacity-30 disabled:cursor-not-allowed transition-all text-slate-500 dark:text-slate-400">
            <span class="material-icons text-sm">chevron_left</span>
          </button>

          <button *ngFor="let page of pagesArray" (click)="onPageChange(page)"
            class="w-9 h-9 flex items-center justify-center rounded-lg text-sm font-bold transition-all"
            [ngClass]="page === currentPage ? 'bg-amber-400 text-white shadow-lg shadow-amber-200 dark:shadow-amber-900/20' : 'text-slate-600 dark:text-slate-300 hover:bg-amber-50 dark:hover:bg-slate-700 hover:text-amber-600'">
            {{ page }}
          </button>

          <button (click)="onPageChange(currentPage + 1)" [disabled]="currentPage === totalPages"
            class="w-9 h-9 flex items-center justify-center rounded-lg border border-slate-200 dark:border-slate-600 hover:bg-slate-50 dark:hover:bg-slate-700/50 hover:text-amber-500 disabled:opacity-30 disabled:cursor-not-allowed transition-all text-slate-500 dark:text-slate-400">
            <span class="material-icons text-sm">chevron_right</span>
          </button>
        </div>
      </div>

    </div>
  </div>

  <!-- Detail Modal -->
  <!-- Image Zoom Modal -->
  <div *ngIf="showImageModal"
    class="fixed inset-0 z-[99999] flex items-center justify-center bg-black/50 backdrop-blur-sm"
    style="z-index: 99999 !important;" (click)="closeImageModal()">

    <!-- Close Button -->
    <button class="absolute top-4 right-4 text-white hover:text-amber-500 transition-colors z-[10000]"
      (click)="closeImageModal()">
      <span class="material-icons text-4xl">close</span>
    </button>

    <!-- Image Container -->
    <div class="relative max-w-[90vw] max-h-[90vh] overflow-hidden rounded-lg shadow-2xl"
      (click)="$event.stopPropagation()">
      <img [src]="selectedImageUrl" class="object-contain max-w-full max-h-[90vh]" alt="Enlarged Image">
    </div>
  </div>

  <app-modal-transaction-parking-detail *ngIf="showDetailModal" [parkingTransaction]="selectedParkingTransaction"
    [userId]="userId" (close)="closeDetailModal()" (openImage)="openImageModal($event)">
  </app-modal-transaction-parking-detail>

  <!-- Edit License Modal -->
  <app-modal-transaction-parking-edit-license [isOpen]="showEditLicenseModal" [data]="editLicenseData"
    (onClose)="closeEditLicenseModal()" (onSuccess)="onEditLicenseSuccess()">
  </app-modal-transaction-parking-edit-license>

  <app-modal-force-enter-transaction [isOpen]="showForceEnterModal" [siteId]="selectedSiteId" [userId]="userId"
    (onClose)="closeForceEnterModal()" (onSuccess)="onForceEnterSuccess()">
  </app-modal-force-enter-transaction>

  <app-modal-force-exit-transaction [isOpen]="showForceExitModal" [siteId]="selectedSiteId" [userId]="userId"
    [transaction]="selectedForceExitTransaction" (onClose)="closeForceExitModal()"
    (onSuccess)="onForceExitSuccess()">
  </app-modal-force-exit-transaction>

  <!-- Bulk Close Modal -->
  <div *ngIf="showBulkCloseModal" class="fixed inset-0 z-[60] flex items-center justify-center">
    <div class="fixed inset-0 bg-slate-900/60 backdrop-blur-sm animate-fade-in" (click)="closeBulkCloseModal()"></div>
    <div
      class="w-full max-w-md bg-white dark:bg-slate-800 rounded-3xl shadow-2xl relative z-10 animate-scale-up border border-slate-100 dark:border-slate-700 m-4 flex flex-col">
      <div
        class="p-6 border-b border-slate-100 dark:border-slate-700 flex justify-between items-center bg-slate-50 dark:bg-slate-800/50 rounded-t-3xl">
        <h2 class="text-xl font-bold flex items-center gap-3 text-slate-800 dark:text-white">
          <div class="w-10 h-10 rounded-xl bg-orange-100 text-orange-500 flex items-center justify-center shrink-0">
            <span class="material-icons text-[22px]">exit_to_app</span>
          </div>
          ทำรายการออกพร้อมกัน
        </h2>
        <button (click)="closeBulkCloseModal()"
          class="w-8 h-8 flex items-center justify-center rounded-xl bg-slate-100 dark:bg-slate-700 text-slate-500 hover:text-slate-800 dark:hover:text-white transition-colors bg-opacity-80">
          <span class="material-icons text-[20px]">close</span>
        </button>
      </div>

      <div class="p-6">
        <div
          class="mb-4 bg-orange-50 dark:bg-orange-900/20 p-3 rounded-xl border border-orange-100 dark:border-orange-800/30 flex items-start gap-3">
          <span class="material-icons text-orange-500 mt-0.5">info</span>
          <div>
            <p class="text-sm text-slate-600 dark:text-slate-300 font-medium leading-relaxed">
              คุณกำลังจะทำรายการรถออกจำนวน <span
                class="font-black text-orange-600 dark:text-orange-400 text-base mx-1">{{ selectedTransactions.size
                }}</span> คัน
            </p>
          </div>
        </div>

        <label
          class="mb-4 flex items-start gap-3 cursor-pointer p-3 rounded-xl border transition-colors"
          [ngClass]="bulkLocalOnly
            ? 'bg-rose-50 dark:bg-rose-900/20 border-rose-200 dark:border-rose-800/40'
            : 'bg-slate-50 dark:bg-slate-900/40 border-slate-100 dark:border-slate-700'">
          <input type="checkbox" [(ngModel)]="bulkLocalOnly"
            class="mt-0.5 w-4 h-4 rounded border-slate-300 text-rose-500 focus:ring-rose-400 shrink-0">
          <span>
            <span class="block text-sm font-bold text-slate-700 dark:text-slate-200">ปิดเฉพาะใน DB (ไม่ส่ง Taiwan)</span>
            <span class="block text-[11px] text-slate-500 dark:text-slate-400 mt-0.5 leading-relaxed">
              ใช้กรณี Taiwan ปิดรายการไปแล้วแต่ไม่ได้แจ้งกลับมา — ระบบจะใส่เวลาออกทันทีโดยไม่ส่งคำสั่งไป Taiwan
            </span>
          </span>
        </label>

        <div *ngIf="!bulkLocalOnly && bulkExitGates.length > 0" class="mb-4 relative">
          <label class="block text-sm font-bold text-slate-700 dark:text-slate-300 mb-2">ประตูออก <span
              class="text-rose-500">*</span></label>
          <div class="relative flex items-center">
            <span class="absolute left-3 material-icons text-slate-400 text-[20px]">door_sliding</span>
            <input type="text" [(ngModel)]="bulkGateSearchText" placeholder="เลือกประตูออก"
              (focus)="isBulkGateDropdownOpen = true" (input)="isBulkGateDropdownOpen = true"
              (blur)="closeBulkGateDropdown()"
              class="w-full bg-white dark:bg-slate-900 border border-slate-300 dark:border-slate-600 text-slate-700 dark:text-slate-200 text-sm rounded-xl focus:ring-orange-500 focus:border-orange-500 block pl-10 pr-10 p-3 transition-all placeholder:text-slate-400 focus:outline-none">
            <span class="absolute right-3 material-icons text-slate-400 text-[20px] pointer-events-none">expand_more</span>
          </div>
          <div *ngIf="isBulkGateDropdownOpen" (mousedown)="$event.preventDefault()"
            class="absolute top-full mt-1 left-0 right-0 z-20 bg-white dark:bg-slate-800 rounded-xl shadow-xl border border-slate-100 dark:border-slate-700 py-1 max-h-56 overflow-y-auto custom-scrollbar">
            <button *ngFor="let g of filteredBulkExitGates" type="button" (click)="selectBulkExitGate(g)"
              class="w-full text-left px-4 py-2.5 text-sm font-medium transition-colors flex items-center justify-between"
              [ngClass]="g.id === bulkExitGateId
                ? 'bg-orange-50 dark:bg-orange-900/20 text-orange-600'
                : 'text-slate-600 dark:text-slate-300 hover:bg-slate-50 dark:hover:bg-slate-700 hover:text-orange-600'">
              {{ g.name }}
              <span *ngIf="g.id === bulkExitGateId" class="material-icons text-[18px]">check</span>
            </button>
            <div *ngIf="filteredBulkExitGates.length === 0" class="px-4 py-3 text-sm text-slate-400">ไม่พบประตูออก</div>
          </div>
          <p class="text-[11px] text-slate-400 mt-1.5">
            ลาน Taiwan จะส่งรายการออกไป Taiwan (ไม่เปิดไม้กั้น) แล้วรอ Taiwan ยืนยันการออกกลับมา
          </p>
        </div>

        <div class="mb-2">
          <label class="block text-sm font-bold text-slate-700 dark:text-slate-300 mb-2">เหตุผล / หมายเหตุ <span
              class="text-rose-500">*</span></label>
          <input type="text" [(ngModel)]="bulkRemark" placeholder="เช่น ผู้ดูระบบทำการตัดยอด, รถออกพร้อมกัน ฯลฯ"
            class="w-full bg-white dark:bg-slate-900 border border-slate-300 dark:border-slate-600 text-slate-700 dark:text-slate-200 text-sm rounded-xl focus:ring-orange-500 focus:border-orange-500 block p-3 shadow-[0_2px_10px_rgb(0,0,0,0.02)] transition-all placeholder:text-slate-400 focus:outline-none">
        </div>
      </div>

      <div
        class="p-6 bg-slate-50 dark:bg-slate-800/50 flex justify-end gap-3 rounded-b-3xl border-t border-slate-100 dark:border-slate-700">
        <button (click)="closeBulkCloseModal()" [disabled]="isBulkClosing"
          class="px-5 py-2.5 text-sm font-bold text-slate-600 dark:text-slate-300 hover:bg-slate-200 dark:hover:bg-slate-700 rounded-xl transition-colors min-w-[100px]">
          ยกเลิก
        </button>
        <button (click)="confirmBulkClose()" [disabled]="isBulkClosing"
          class="px-5 py-2.5 text-sm font-bold text-white bg-orange-500 hover:bg-orange-600 rounded-xl shadow-md shadow-orange-500/20 hover:shadow-lg transition-all active:scale-95 disabled:opacity-50 min-w-[120px] flex justify-center items-center gap-2">
          <span *ngIf="isBulkClosing" class="material-icons animate-spin text-[18px]">autorenew</span>
          <span>{{ isBulkClosing ? 'กำลังบันทึก...' : 'บันทึกพร้อมกัน' }}</span>
        </button>
      </div>
    </div>
  </div>
